<template>
    <div>
        <div class="main-content">
            <div class="logo-wrapper text-center">
                <img src="@/assets/images/logo/logo.png" alt="logo principal" width="75" />
                <img src="@/assets/images/logo/logop2.png" class="ml-2" alt="logo secundária" height="35" />
            </div>
            <div class="mt-5 info-alert">
                <i class="fa fa-info-circle mr-2 mt-1"></i>
                <div class="alert-text">
                    Este formulário foi criado para que você possa exercer seus direitos previstos na Lei Geral de
                    Proteção
                    de Dados Pessoais (LGPD - Lei nº 13.709/2018).<br><br>

                    Por meio dele, você poderá:
                    <ul>
                        <li>Solicitar informações sobre os dados pessoais que temos sobre você;</li>
                        <li>Corrigir ou atualizar seus dados;</li>
                        <li>Solicitar a exclusão dos seus dados;</li>
                        <li>Revogar consentimentos previamente concedidos;</li>
                        <li>Fazer questionamentos sobre o tratamento dos seus dados pessoais.</li>
                    </ul>

                    Nos comprometemos a analisar sua solicitação com cuidado e responder dentro dos prazos estabelecidos
                    pela legislação. Para isso, é importante preencher o formulário com as informações solicitadas, que
                    serão utilizadas exclusivamente para atender à sua demanda e garantir a segurança do
                    processo.<br><br>

                    Se tiver dúvidas, entre em contato conosco pelo e-mail:
                    <strong>sistemas@it4d.com.br</strong> ou pelo telefone <strong>(11) 3172-0004 – Ramal 1108</strong>.
                </div>
            </div>

            <div class="card-body mt-2">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">DPO - Data Protection Officer</div>
                        </div>
                        <hr style="margin-top: -4px" />
                        <div class="col-md-12">
                            <form>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="sistema">
                                            <span class="required">*</span> Sistema:
                                        </label>
                                        <v-select v-model="lgpd.project_id" :options="projects"
                                            :reduce="(project) => project.id" :label="'name'" disabled />
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="Name">
                                            <span class="required">*</span> Nome:
                                        </label>
                                        <input type="text" id="Name" class="form-control" v-model="lgpd.name" />
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <label for="Email">
                                            <span class="required">*</span> E-mail:
                                        </label>
                                        <input type="email" id="Email" class="form-control" v-model="lgpd.email" />
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for="Number">
                                            <span class="required">*</span> Telefone:
                                        </label>
                                        <input type="tel" id="Number" class="form-control" v-model="lgpd.number"
                                            v-mask="'(99)99999-9999'" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="description">
                                        <span class="required">*</span> Descrição:
                                    </label>
                                    <textarea id="description" class="form-control" v-model="lgpd.description"
                                        rows="4"></textarea>
                                </div>

                                <span class="required_fields">
                                    <span class="required">*</span>
                                    <strong>Campos obrigatórios</strong>
                                </span>

                                <div class="block text-right mb-1">
                                    <router-link to="/lgpds" class="btn btn-back">
                                        <i class="fa fa-arrow-left"></i> Voltar
                                    </router-link>
                                    <a class="btn btn-add ml-1" @click="save">
                                        Enviar
                                        <i class="fa fa-paper-plane"></i>
                                    </a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from "vue-select";
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
    name: "imageUpload",
    data() {
        return {
            lgpd: {
                project_id: "",
                name: "",
                email: "",
                number: "",
                description: "",
                status: 0,
            },
            projects: [],
        };
    },
    methods: {
        save: function () {
            const self = this;
            let api = self.$store.state.api + "lgpds-public";

            axios
                .post(api, self.lgpd)
                .then((response) => {
                    self.$message(
                        "Sucesso",
                        `Informações guardadas com sucesso`,
                        "success"
                    );
                    self.lgpd = {
                        project_id: Number(self.$route.params.system),
                        name: "",
                        email: "",
                        number: "",
                        description: "",
                        status: 0,
                    };

                    this.$router.push("/public/lgpd/" + self.$route.params.system);
                })
                .catch((error) => {
                    self.$message(null, error.response.data, "error");
                });
        },


        getProjects: function () {
            const self = this;
            const api = self.$store.state.api + "projects-public?paginated=false";

            axios
                .get(api)
                .then((response) => {
                    self.projects = response.data.data || response.data.projects;

                    let id = self.$route.params.system;

                    if (id) {
                        setTimeout(() => {
                            self.lgpd.project_id = Number(id);
                        }, 100);
                    }
                })
                .catch((error) => {
                    self.$message(null, error.response.data, "error");
                });
        },
    },
    mounted: function () {
        const self = this;
        self.getProjects(); // <-- Adicionado



    },
    components: {
        vSelect,
        BaseCrud,
    },
};
</script>

<style scoped>
.logo-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    margin-bottom: 1.5rem;
    margin-top: 1rem;
}

.logo-wrapper img {
    margin-top: 50px;
    margin-bottom: -30px;
    max-width: 100%;
    height: 70px;
}

.card-body {
    padding: 3rem !important;
}

.card {
    margin-bottom: 2rem;
}

.form-group {
    margin-bottom: 2.5rem;
}

textarea.form-control {
    resize: vertical;
}

.required_fields {
    display: inline-block;
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.info-alert {
    background-color: #eef6fb;
    border-left: 5px solid #3498db;
    color: #2c3e50;
    padding: 15px 20px;
    border-radius: 4px;
    margin: 0 auto 20px auto;
    max-width: 95%;
    font-size: 15px;
    display: flex;
    align-items: center;
}

pre {
    background-color: #eef6fb;
}



@media (max-width: 768px) {
    .info-alert {
        flex-direction: column;
        align-items: flex-start;
    }

    .info-alert i {
        margin-bottom: 8px;
    }
}
</style>
